import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/interfaces/response.interface';
import { Status } from 'src/app/configs/status';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { IProduct } from 'src/app/interfaces/product.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  public productsSubject: BehaviorSubject<IProduct[]>;
  public products: Observable<IProduct[]>;

  public cache = {
    products: null
  };

  constructor(private http: HttpClient) {
    this.productsSubject = new BehaviorSubject<IProduct[]>(null);
    this.products = this.productsSubject.asObservable();
  }

  public create(data: FormData) {
    return this.http.post(`${environment.apiUrl}/products/create`, data);
  }

  public update(data: FormData, id: number) {
    return this.http.post(`${environment.apiUrl}/products/update/${id}`, data);
  }

  public read(id: number, purgeCache?: boolean) {

    if (!purgeCache && this.cache.products !== null) {
      const cache = this.cache.products.find(c => c.id_product === id);

      if (cache) {
        const r: IResponse = {
          success: true,
          status: Status.OK,
          data: cache
        };

        return of(r);
      }
    }

    return this.http.get(`${environment.apiUrl}/products/read/${id}`);
  }

  public delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/products/delete/${id}`);
  }

  public list(purgeCache?: boolean) {

    if (!purgeCache && this.cache.products !== null) {
      this.productsSubject.next(this.cache.products);
      return of(this.cache.products);
    }

    return this.http.get(`${environment.apiUrl}/products/all`)
      .pipe(map((response: IResponse) => {
        this.cache.products = response.data;
        this.productsSubject.next(response.data || []);
      })).subscribe();
  }

  public empty() {
    this.productsSubject.next([]);
  }

  public purge() {
    this.cache.products = null;
    this.empty();
    this.list(true);
  }
}
